import React, { Component } from 'react';
import '../../../styles/scss/style.css';

//Components
import TextHeadingOne from '../atoms/TextHeadingTwo';
import TextParagraph from '../atoms/TextParagraph';
import FormButton from '../atoms/FormButton';
import LabeledTextfield from '../molecules/LabeledTextfield';
import Modal from '../organisms/Modal';


//Returning the component
class FormChangeName extends Component {
	render() {
		return (
			<Modal modalClass={this.props.modalClass} onClick={this.props.onClose}>
			<form className={`form ${this.props.formWrapperClassType}`}>
				<TextHeadingOne text={this.props.heading} />
				<TextParagraph text={this.props.paragraph} />
				{/* name */}
				<LabeledTextfield 
					formGroupClassType={this.props.formGroupClassType}
					labelFor="name"
					labelText="Name"
					labelId="name"
					textfieldClassType={this.props.textfieldClassType}
					textfieldId="name"
					textfieldPlaceholder={this.props.name}
					textfieldName='nameInput'
					onChange={this.props.onChange}
					value={this.props.value}
					errorMessageClassType={this.props.errorMessageClassType}
					errorMessageText={this.props.errorMessageName}
					required={true}
					inputType="text"
				/>
				<FormButton text={this.props.buttonLabel} classType="btn--fullWidth" onClick={this.props.onClick} />
			</form>
		</Modal>
		)
	}
}

export default FormChangeName;


// WEBPACK FOOTER //
// ./src/redux/components/organisms/FormChangeName.jsx